<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { RemoteIcon } from "@infinitro/icons";
let { icon = null, activeTab = false, inactiveTab = false, iconCustomStyles = "" } = $props();
</script>

{#if typeof icon === 'string'}
	{#if icon.endsWith('.svg') || icon.endsWith('.png') || icon.endsWith('.jpg') || /^(https?:|data:)/.test(icon)}
		<img
			src={icon}
			alt={$t(Verbiage.icon_alt, 'alts')}
			class="icon"
			style={iconCustomStyles}
			class:icon-inactive={inactiveTab}
			class:icon-active={activeTab}
		/>
	{:else if $stateUi.layout.useRemoteIcons === true}
		<RemoteIcon {icon} size={20} />
	{:else}
		<i class={icon} style={iconCustomStyles}></i>
	{/if}
{:else if icon != null}
	{@const Icon = icon}
	<span class="icon" style={iconCustomStyles}>
		<Icon hover={activeTab} size={20} />
	</span>
{/if}

<style>
	.icon {
    display: flex;
    width: 16px;
    align-items: center;
    justify-content: center
}
	.icon-inactive {
    opacity: 0.6
}
	.icon-inactive:hover {
    opacity: 1
}
	.icon-active {
    opacity: 1
}
</style>
